import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const taxesModule = defineModule({
  name: "taxes",
  label: "Taxes",
  requires: ["core", "accounts", "configuration", "audit"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "settings/taxes",
        permission: "taxes.view_taxclass",
        page: () => import("./admin/TaxClassesPage"),
      },
    ],
    nav: [
      {
        id: "tax-classes",
        group: "settings",
        label: "taxes:nav",
        icon: "wallet",
        to: "/settings/taxes",
        permission: "taxes.view_taxclass",
        order: 4,
      },
    ],
  },
});
